import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-24 bg-surface border-t border-white/5 relative overflow-hidden" data-id="element-55">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-gradient-to-t from-cyan/10 to-transparent pointer-events-none" data-id="element-56"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10 text-center" data-id="element-57">
        <FadeIn data-id="element-58">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-59">
            ⏰ EL PRECIO CIERRA PRONTO
          </h2>
          <p className="text-xl text-gray-400 mb-12" data-id="element-60">
            Elegí tu plan y empezá a blindar tu moto hoy mismo.
          </p>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center gap-6 mb-12" data-id="element-61">
          <FadeIn delay={0.1} className="flex-1 max-w-md mx-auto md:mx-0 w-full" data-id="element-62">
            <a href="https://fegion.shop/cart/46537414901899:1" className="flex flex-col items-center justify-center p-8 bg-surfaceLight border border-white/10 rounded-2xl hover:border-white/30 transition-all h-full" data-id="element-63">
              <span className="text-lg font-bold text-white mb-2" data-id="element-64">
                📘 MEGA PACK MOTOCICLISTA
              </span>
              <span className="text-sm text-gray-400 mb-6 text-center" data-id="element-65">
                6 Módulos + 5 Bonos · Todos los niveles
              </span>
              <div className="flex items-center gap-3 mb-6" data-id="element-66">
                <span className="text-gray-500 line-through text-lg" data-id="element-67">
                  $51.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-68">
                  $19.990 ARS
                </span>
              </div>
              <div className="w-full py-3 px-6 rounded-xl font-bold text-white border border-white/20 hover:bg-white/5 transition-colors uppercase tracking-wider text-sm" data-id="element-69">
                → QUIERO MI MEGA PACK
              </div>
            </a>
          </FadeIn>

          <FadeIn delay={0.2} className="flex-1 max-w-md mx-auto md:mx-0 w-full" data-id="element-70">
            <a href="https://fegion.shop/cart/46537415327883:1" className="flex flex-col items-center justify-center p-8 bg-cyan rounded-2xl hover:bg-cyan/90 transition-all animate-pulse-glow shadow-lg h-full relative" data-id="element-71">
              <span className="text-lg font-bold text-background mb-2" data-id="element-72">
                🏆 MEGA PACK + MOTO TALLER PRO ⭐
              </span>
              <span className="text-sm text-background/80 font-medium mb-6 text-center" data-id="element-73">
                6 Módulos + 5 Bonos + Sistema Emprendimiento
              </span>
              <div className="flex items-center gap-3 mb-6" data-id="element-74">
                <span className="text-background/50 line-through text-lg" data-id="element-75">
                  $69.000
                </span>
                <span className="text-3xl font-bold text-background" data-id="element-76">
                  $27.990 ARS
                </span>
              </div>
              <div className="w-full py-3 px-6 rounded-xl font-bold text-cyan bg-background hover:bg-background/90 transition-colors uppercase tracking-wider text-sm" data-id="element-77">
                → QUIERO EL MEGA PACK + MOTO TALLER PRO
              </div>
            </a>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-78">
          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400" data-id="element-79">
            <div className="flex items-center gap-2" data-id="element-80">
              <Lock className="w-4 h-4 text-cyan" data-id="element-81" />
              <span data-id="element-82">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-83">
              <Zap className="w-4 h-4 text-cyan" data-id="element-84" />
              <span data-id="element-85">Acceso en 5 minutos</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-86">
              <ShieldCheck className="w-4 h-4 text-cyan" data-id="element-87" />
              <span data-id="element-88">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-89">
              <CreditCard className="w-4 h-4 text-cyan" data-id="element-90" />
              <span data-id="element-91">Mercado Pago</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}